import { render, staticRenderFns } from "./OrdersEditModal.vue?vue&type=template&id=0495ac5c&"
import script from "./OrdersEditModal.vue?vue&type=script&lang=js&"
export * from "./OrdersEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports